import { useTranslate } from "../../../../language/i18n";
import AccordionItem from "../../../shared/AccordionItem/AccordionItem";
import { FileDownload } from "../../../shared/File/FileDownload/FileDownload";

interface AttachmentFile {
  id: string;
  url: string;
  name: string;
  createdBy?: string;
  createdDateTime?: string;
}

interface AttachmentsProps {
  files?: AttachmentFile[];
}

const Attachments = ({ files }: AttachmentsProps) => {
  const translate = useTranslate();

  if (!files?.length) return null;

  return (
    <AccordionItem title={translate("ATTACHMENTS")}>
      <ul>
        {files.map(file => (
          <li key={file.id}>
            <FileDownload file={file} showDetails={false} />
          </li>
        ))}
      </ul>
    </AccordionItem>
  );
};

export default Attachments;
